import { render, staticRenderFns } from "./fatFileList.vue?vue&type=template&id=aaf6e46c&scoped=true"
import script from "./fatFileList.vue?vue&type=script&lang=js"
export * from "./fatFileList.vue?vue&type=script&lang=js"
import style0 from "./fatFileList.vue?vue&type=style&index=0&id=aaf6e46c&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf6e46c",
  null
  
)

export default component.exports